import { render, staticRenderFns } from "./UserMessagesShow.vue?vue&type=template&id=77b0dbb4&scoped=true&"
import script from "./UserMessagesShow.vue?vue&type=script&lang=js&"
export * from "./UserMessagesShow.vue?vue&type=script&lang=js&"
import style0 from "./UserMessagesShow.vue?vue&type=style&index=0&id=77b0dbb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b0dbb4",
  null
  
)

export default component.exports